import TYPES from '../types';

function typeIsPc(isPc) {
  return { type: TYPES.DEVICE_IS_PC, payload: { isPc } };
}

export default {
  typeIsPc
};